<template>
  <div class="menu-item" :class="{ 'menu-item-last': isLast }">
    <div class="menu-title">
        <span>{{ menuData.title }}</span>
      </div>
    <div ref="containerRef" class="tab-list-wrapper">
      <div ref="tabListRef" class="tab-list" :class="{ 'tab-list-expanded': expandStatus === 1 }">
        <div v-for="item in menuList" class="tab-item" :class="{
          'tab-item-checked': checkedId == item.id,
          'tab-item-unchecked': checkedId != item.id
        }" @click="checkedChange(item)">
          <div class="item-info">
            <div class="item-name" v-if="item.children && item.children.length > 0">{{ item.name }}
              <img class="icon" v-if="checkedId != item.id" src="@/assets/images/top.png" alt="" />
              <img class="icon" v-else src="@/assets/images/top-bule.png" alt="" />
            </div>
            <div v-else>{{ item.name }}</div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="showExpandBtn" @click="expand" class="expand-btn">
      <div v-if="expandStatus === 0"><img class="icon" src="@/assets/images/top.png"  alt="" /></div>
      <div v-else><img class="icon" src="@/assets/images/bom.png" alt="" /></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuData: {
      type: Object,
      default: null
    },
    checkedId: {
      type: [String, Number],
      default: ''
    },
    isLast: {
      type: Boolean,
      default: false
    },
    containerWidth: {
      type: Number,
      default: 780
    },
    containerPercent: {
      // 优先级高
      type: Number,
      default: null
    }
  },
  data() {
    return {
      menuList: [],
      expandStatus: 0,
      contentWidth: 0,
      visibleItems: [],
      allItemsWidth: 0,
      effectiveContainerWidth: 0 // 实际使用的容器宽度
    }
  },
  computed: {
    showExpandBtn: function () {
      return this.allItemsWidth > this.effectiveContainerWidth
    }
  },
  methods: {
    checkedChange(e) {
      this.$emit('checkedChange', e)
    },
    expand() {
      this.expandStatus = this.expandStatus === 0 ? 1 : 0
      this.updateVisibleItems()
    },
    updateVisibleItems() {
      if (this.expandStatus === 1) {
        this.menuList = [...this.menuData.content]
      } else {
        let currentWidth = 0
        const visibleItems = []

        for (let i = 0; i < this.menuData.content.length; i++) {
          const item = this.menuData.content[i]
          const itemWidth = this.getItemWidth(i)

          if (currentWidth + itemWidth > this.effectiveContainerWidth) {
            break
          }

          visibleItems.push(item)
          currentWidth += itemWidth
        }

        this.menuList = visibleItems
      }
    },
    getItemWidth(index) {
      if (!this.$refs.tabListRef || !this.$refs.tabListRef.children || !this.$refs.tabListRef.children[index]) {
        return 0
      }

      return this.$refs.tabListRef.children[index].offsetWidth
    },
    calculateContentWidth() {
      if (!this.menuData || !this.menuData.content || this.menuData.content.length === 0) {
        this.contentWidth = 0
        this.allItemsWidth = 0
        return
      }

      // 计算实际容器宽度
      this.calculateEffectiveContainerWidth()

      this.menuList = [...this.menuData.content]

      this.$nextTick(() => {
        if (!this.$refs.tabListRef) return

        // 计算所有项目的总宽度
        this.allItemsWidth = Array.from(this.$refs.tabListRef.children)
          .reduce((total, child) => total + child.offsetWidth, 0)

        // 更新可见项目
        this.updateVisibleItems()
      })
    },
    calculateEffectiveContainerWidth() {
      if (this.containerPercent !== null && this.containerPercent > 0 && this.$refs.containerRef) {
        const parentWidth = this.$refs.containerRef.parentElement.offsetWidth
        this.effectiveContainerWidth = parentWidth * (this.containerPercent / 100)
      } else {
        this.effectiveContainerWidth = this.containerWidth
      }
    }
  },
  mounted() {
    this.calculateContentWidth()

    // 监听窗口大小变化，重新计算
    window.addEventListener('resize', this.calculateContentWidth)
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.calculateContentWidth)
  },
  watch: {
    menuData: {
      handler() {
        this.calculateContentWidth()
      },
      deep: true
    },
    containerWidth() {
      this.calculateContentWidth()
    },
    containerPercent() {
      this.calculateContentWidth()
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item {
  display: flex;
  grid-auto-flow: column;
  justify-content: space-between;
  .menu-title {
    width: 76px;
    height: 28px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1D2129;
    line-height: 28px;
    text-align: left;
    margin-right: 20px;
    flex-wrap: wrap;
    overflow: hidden;
    white-space: nowrap;
    grid-template-columns: 76px 1fr auto; 
    gap: 20px; 
    align-items: start; 
  }

  .tab-list-wrapper {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    width: 100%; 
    max-width: 100%; 
    box-sizing: border-box; 
  }

  .tab-list {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    .tab-item {
      height: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #1D2129;
      align-items: center;
      border-radius: 6px;
      background: transparent;
      box-sizing: border-box;
      padding: 4px 12px;
      display: flex;
      margin-bottom: 20px;
      position: relative;
      cursor: pointer;
      margin-right: 24px;
      .tab-item:last-child {
        margin-right: 0; /* 最后一个元素无需右 margin */
      }
      .item-info {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%
      }

      .item-name {
        max-width: 165px;
      }

      .arrow {
        width: 10px;
        height: 10px;
        background: transparent;
        transform: rotate(45deg);
        position: absolute;
        right: -20px;
      }

      .arrow-mask {
        width: 12px;
        height: 20px;
        background: #f3f9ff;
        position: absolute;
        right: -15px;
        z-index: 1;
      }
    }
    &.tab-list-expanded {
      .tab-item {
        margin-bottom: 12px; 
      }
      // 整个列表底部与下方保持8px（通过容器内边距实现）
      padding-bottom: 8px; 
      margin-bottom: 0; 
    }

    .tab-item-checked {
      background: #1941891A;
      color: #194189;

      .arrow {
        background: #0050de;
      }
    }

    .tab-item-unchecked:hover {
      // background: rgba(0, 80, 222, 0.05);
      color: #194189;
    }
  }

  .expand-btn {
    color: #221e1f;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 0px;
    margin-bottom: 5px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1D2129;
    margin-top: 5px;
  }
}

.menu-item-last {
  border-bottom: 0;
}
</style>